import { ErrorRouteName } from './routerErrors'

export const RouteName = {
  Home: 'Home',
  Redirect: 'Redirect',
  Missions: 'Missions',
  MissionHiddenRewards: 'MissionHiddenRewards',
  MissionStreaks: 'MissionStreaks',
  MissionStreaksAdjustments: 'MissionStreaksAdjustments',
  MissionStreaksBrowserUpdate: 'MissionStreaksBrowserUpdate',
  MissionStreaksNoWalletDetected: 'MissionStreaksNoWalletDetected',
  MissionDataSaved: 'MissionDataSaved',
  FAQ: 'FAQ',
  Feedback: 'Feedback',
  FeedbackSubmitted: 'FeedbackSubmitted',
  TermsOfUse: 'TermsOfUse',
  RewardWon: 'RewardWon',
  HiddenRewardFoundAsAnon: 'HiddenRewardFoundAsAnon',
  HiddenRewardFound: 'HiddenRewardFound',
  Logout: 'Logout',
  Debug: 'Debug',
  DebugDeviceApi: 'DebugDeviceApi',
  DebugEnvs: 'DebugEnvs',
  DebugLocale: 'DebugLocale',
  DebugUiDialog: 'DebugUiDialog',
  DebugUiBottomSheet: 'DebugUiBottomSheet',
  DebugRegisterFcmToken: 'DebugRegisterFcmToken',
  DebugToast: 'DebugToast',
  DebugJsonForm: 'DebugJsonForm',
  DebugMiniConfig: 'DebugMiniConfig',
  NewUserBonus: 'WelcomeNewUserBonus',
  NotFound: 'NotFound',
  DebugInfo: 'DebugInfo',
  UpdateRequired: 'UpdateRequired',
  Maintenance: 'Maintenance',
  Points: 'Points',
  PointsHistory: 'PointsHistory',
  PointsNoWalletDetected: 'PointsNoWalletDetected',
  ActivateWallet: 'ActivateWallet',
  CustomForm: 'CustomForm',
  ...ErrorRouteName
} as const
